import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

export default function WorkerLogin() {
  const [phone, setPhone] = useState("");
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/auth/login`, {
        phone,
        pin,
      });

      localStorage.setItem("token", response.data.token);
      localStorage.setItem("user", JSON.stringify(response.data.user));

      toast.success("Login successful!");
      navigate("/worker/dashboard");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="worker-ui min-h-screen bg-gradient-to-b from-[#0a2240] to-[#0f325c]">
      <div className="px-6 py-12">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white/10 backdrop-blur rounded-2xl mb-6 border border-white/20">
            <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">VisualOps</h1>
          <p className="text-lg text-white/70">Training Portal</p>
        </div>

        <div className="bg-white rounded-2xl p-6 shadow-2xl">
          <form onSubmit={handleLogin} className="space-y-6">
            <div>
              <Label htmlFor="phone" className="text-base font-semibold text-slate-800 mb-2 block">
                Phone Number
              </Label>
              <Input
                id="phone"
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Enter your phone number"
                required
                className="h-14 text-xl text-center tracking-wider border-2"
                data-testid="worker-phone-input"
              />
            </div>

            <div>
              <Label htmlFor="pin" className="text-base font-semibold text-slate-800 mb-2 block">
                4-Digit PIN
              </Label>
              <Input
                id="pin"
                type="password"
                value={pin}
                onChange={(e) => setPin(e.target.value.slice(0, 4))}
                placeholder="••••"
                maxLength={4}
                required
                className="h-14 text-2xl text-center tracking-[0.5em] font-mono border-2"
                data-testid="worker-pin-input"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="thumb-button w-full bg-gradient-to-r from-[#0a2240] to-[#2e7fd4] hover:from-[#0f325c] hover:to-[#1c64b0] text-white rounded-xl shadow-lg"
              data-testid="worker-login-button"
            >
              {loading ? "LOGGING IN..." : "LOGIN"}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <Link to="/admin/login" className="text-[#2e7fd4] hover:text-[#1c64b0] font-medium">
              Admin Login →
            </Link>
          </div>
        </div>

        <p className="text-center text-white/50 text-sm mt-8">
          VisualOps Training Portal © {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
}
